import '../styles/input.css'

export default function Input({placeholder=''}) {
  return (
    <input className='form-input' placeholder={placeholder} type={'text'}/>
  )
}
